// Web Audio sfx, ludo/bubble pattern: a fresh BufferSource per play → parallel
// playback. Loading is optional (game stays silent if a file fails). Safari:
// resume() on the first gesture, guard suspended in play().
import dropUrl from '../sfx/drop.wav';
import landUrl from '../sfx/land.wav';
import winUrl  from '../sfx/win.wav';
import loseUrl from '../sfx/lose.wav';

const actx = new (window.AudioContext || (window as unknown as { webkitAudioContext: typeof AudioContext }).webkitAudioContext)();
const buffers = new Map<string, AudioBuffer>();

export function resumeAudio(): void { if (actx.state === 'suspended') actx.resume(); }

async function load(url: string): Promise<void> {
  try {
    const resp = await fetch(url);
    const arr = await resp.arrayBuffer();
    buffers.set(url, await actx.decodeAudioData(arr));
  } catch { /* optional — stay silent */ }
}

function play(url: string, vol = 1): void {
  if (actx.state === 'suspended') return;
  const buf = buffers.get(url);
  if (!buf) return;
  try {
    const src = actx.createBufferSource();
    const gain = actx.createGain();
    gain.gain.value = vol;
    src.buffer = buf;
    src.connect(gain);
    gain.connect(actx.destination);
    src.start();
  } catch { /* ignore */ }
}

export function preloadAudio(): void {
  [dropUrl, landUrl, winUrl, loseUrl].forEach(load);
}

export const playDrop = () => play(dropUrl, 0.7);
export const playLand = () => play(landUrl, 0.7);
export const playWin  = () => play(winUrl, 0.8);
export const playLose = () => play(loseUrl, 0.8);
